module.exports = __webpack_public_path__ + "img/guest.ae71183a.png";